<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex md8>
        <div style="padding:0; position:relative;">
          <v-layout row wrap class="control">
            <v-flex xs12 md12 class="text-xs-center">
              <div class="pb-3">
                <el-select
                  v-model="form.shop_id"
                  placeholder="Select"
                  :size="`small`"
                  class="pr-2"
                  @change="onShopChanged"
                >
                  <el-option
                    :label="shop.name"
                    :value="shop.shop_id"
                    :key="index"
                    v-for="(shop, index) in shops"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="form.cluster_id"
                  placeholder="Select"
                  :size="`small`"
                  class="pr-2"
                >
                  <el-option
                    :label="cluster.delivery"
                    :value="cluster.id"
                    :key="index"
                    v-for="(cluster, index) in clusters"
                  ></el-option>
                </el-select>
                <el-button type="primary" class="ml-2" size="mini" @click="searchOrder">ค้นหา</el-button>
              </div>
            </v-flex>
          </v-layout>
          <gmap-map
            ref="mapRef"
            :center="mapCenter"
            :options="mapConfig"
            :zoom="16"
            map-type-id="roadmap"
            class="map-container"
            @center_changed="updateCenter"
          >
            <template v-if="markers.length>0">
              <!-- SHOP MARKER -->
              <GmapMarker
                v-if="origin!=null"
                :position="origin.position"
                :clickable="false"
                :draggable="false"
              />

              <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                :draggable="false"
                :label="m.label"
                :icon="{ url: m.url}"
                @click="onMarkerClicked(m)"
              />
            </template>
          </gmap-map>
        </div>
      </v-flex>
      <v-flex md4 fill-height class="px-2">
        <div class="fixed-card ma-2">
          <v-card
            v-for="(item, index) in markers"
            :key="index"
            style="min-height:60px;"
            :elevation="2"
            class="pa-2 ma-2 cursor"
            @click="toggleSelect(index)"
          >
            <el-checkbox v-model="item.selected"></el-checkbox>
            <span class="grey--text">&nbsp;{{item.order_reference}}</span>
            -
            <strong>{{item.order_id}}</strong>
            <div class="line-1-elipsis">
              <strong>สถานะ :</strong>
              {{item.status}}
            </div>
            <div class="line-1-elipsis">
              <strong>ส่งที่ :</strong>
              {{item.delivery_info_json.whereTo.address.text}}
            </div>
          </v-card>

          <div
            class="mt-3 pa-2"
            style="position:sticky; bottom:5px; width:95%; margin:0 auto; z-index: 9999;"
          >
            <el-button
              type="primary"
              style="width:100%;"
              @click="submit()"
              :disabled="markers.filter(x=>x.selected).length<1"
            >
              สร้างเส้นทาง
              <i
                v-if="markers.filter(x=>x.selected).length>=1"
              >({{markers.filter(x=>x.selected).length}})</i>
            </el-button>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog v-model="routeDialog" persistent scrollable max-width="400px">
      <v-card v-if="routeData!=null">
        <v-card-title>
          <strong>เส้นทาง</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 350px;">
          <el-timeline>
            <el-timeline-item
              v-for="(stop, index) in routeData.driver.stops"
              :key="index"
              :size="`large`"
            >
              <strong class="black--text">{{stop.addresses.th_TH.displayString}}</strong>
              <br />
              <!-- {{stop.contact.name}} | {{stop.contact.mobile}} -->
            </el-timeline-item>
          </el-timeline>
        </v-card-text>
        <v-card-actions>
          <v-layout class="px-2">
            <v-flex>
              <div class="font-weight-bold">Schedule At</div>
              {{routeData.driver.scheduleAt| moment("DD MMM YYYY HH:mm")}}
            </v-flex>
            <v-flex class="text-xs-right">
              <!--
              <h3
                class="headline font-weight-bold"
              >Total : ฿ {{routeData.driver.quotedTotalFee.amount}}</h3>
              -->
            </v-flex>
          </v-layout>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <el-button text @click="routeDialog = false">ปิด</el-button>
          <el-button type="primary" @click="requestDriver()">เรียกคนขับ</el-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Service from "../../services";

import moment from "moment";
export default {
  props: {
    props: []
  },
  data() {
    return {
      loading: null,
      routeDialog: false,
      daterange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      description: "",
      form: {
        lat: "",
        lng: "",
        shop_id: null,
        cluster_id: null
      },
      mapCenter: {
        lat: 13.736717,
        lng: 100.523186
      },
      origin: null,
      mapConfig: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true,
        zoom: 12
      },
      shops: [],
      clusters: [],
      markers: [],
      routeData: null
    };
  },
  created() {
    Service.Shop.gets().then(res => {
      if (res.success) {
        this.shops = res.data.filter(x => x.status == "published");
      }
    });
    this.searchOrder();
  },
  methods: {
    searchOrder() {
      this.markers = [];

      let params = {
        shop_id: this.form.shop_id,
        cluster_id: this.form.cluster_id
      };

      /*
      let params = {
        shop_id: 73,
        cluster_id: 1
      };
      */

      var queryString = Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&");
      Service.Order.gets(queryString).then(res => {
        if (res.data.length > 0) {
          this.origin = {
            position: new google.maps.LatLng(
              res.data[0].shop.latitude,
              res.data[0].shop.longitude
            )
          };

          res.data.map(item => {
            if (
              item.status != "pending" &&
              item.status != "new" &&
              item.status != "cancelled"
            ) {
              let url = require("../../assets/img/marker-a.png");
              if (item.status == "cooking") {
                url = require("../../assets/img/marker-b.png");
              }
              this.markers.push({
                ...item,
                selected: false,
                label: {
                  text: "#" + item.order_id,
                  fontWeight: "bold"
                },
                info: item.delivery_info_json.whereTo.name,
                position: new google.maps.LatLng(
                  item.delivery_info_json.whereTo.lat,
                  item.delivery_info_json.whereTo.lng
                ),
                url: url,
                statusUrl: url
              });
            }
          });

          this.$refs.mapRef.$mapPromise.then(map => {
            map.panTo({
              lat: parseFloat(res.data[0].shop.latitude),
              lng: parseFloat(res.data[0].shop.longitude)
            });
          });
        }
      });
    },
    toggleSelect(index) {
      this.markers[index].selected = !this.markers[index].selected;
      if (this.markers[index].selected) {
        this.markers[index].url = require("../../assets/img/marker-c.png");
      } else {
        this.markers[index].url = this.markers[index].statusUrl;
      }
    },
    onShopChanged() {
      let index = this.shops.findIndex(x => x.shop_id == this.form.shop_id);
      this.clusters = this.shops[index].cluster_json;
    },
    onMarkerClicked(m) {
      let index = this.markers.findIndex(x => x.order_id == m.order_id);
      this.markers[index].selected = !this.markers[index].selected;

      if (this.markers[index].selected) {
        this.markers[index].url = require("../../assets/img/marker-c.png");
      } else {
        this.markers[index].url = this.markers[index].statusUrl;
      }
    },
    updateCenter(latLng) {
      this.form.lat = latLng.lat();
      this.form.lng = latLng.lng();
    },
    submit() {
      let selectedOrders = [];
      this.markers.map(item => {
        if (item.selected) {
          selectedOrders.push(item.order_id);
        }
      });

      if (selectedOrders.length < 1) {
        return;
      }

      let data = {
        scheduleAt: "asap",
        serviceType: "MOTORCYCLE",
        specialRequests: ["LALABAG"],
        requesterContact: {
          name: "Halalize Co",
          phone: "0922499203"
        },
        sms: true,
        shop_id: this.form.shop_id,
        cluster_id: this.form.cluster_id,
        orders: selectedOrders
      };

      this.showLoading();
      Service.Delivery.getClusterDriverFee(data).then(res => {
        console.log(res);
        if (res.success) {
          this.routeData = res.data;
          this.routeDialog = true;
        }
        this.hideLoading();
      });
    },
    requestDriver() {
      //console.log(JSON.stringify(this.routeData));
      this.showLoading();
      Service.Delivery.requestClusterDriver(this.routeData).then(res => {
        console.log(res);
        if (res.success) {
          this.routeDialog = false;
        }
        this.hideLoading();
      });
    },
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
    },
    hideLoading() {
      this.loading.close();
    }
  }
};
</script>
<style lang="scss" scoped>
.map-container {
  height: calc(100vh - 12vh);
}

.control {
  padding: 0;
  position: absolute;
  top: 10px;
  z-index: 99;
  width: 100%;
}

.fixed-card {
  position: relative;
  background-color: #eee;
  overflow-y: auto;
  height: calc(100vh - 12vh);
}
</style>